import {createSelector, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {PaymentInfo, PaymentStatus, PaymentStatusValues} from '../../schema'

const initialState: PaymentInfo = {
  paymentSessionId: null,
  status: PaymentStatusValues.Inactive,
  error: undefined
}

export const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setPaymentSessionId: (state, action: PayloadAction<string>) => {
      state.paymentSessionId = action.payload
    },
    setPaymentStatus: (state, action: PayloadAction<PaymentStatus>) => {
      state.status = action.payload
    },
    setPaymentError: (state, action: PayloadAction<string | undefined>) => {
      state.error = action.payload
    },
    clearPayment: () => {
      return {...initialState}
    }
  }
})

// selectors
export const selectPayment = (state: any): PaymentInfo => {
  return state.payment
}

export const selectPaymentSessionId = createSelector(
  selectPayment,
  (payment: PaymentInfo): string | null | undefined => {
    return payment.paymentSessionId
  }
)

export const selectPaymentStatus = createSelector(
  selectPayment,
  (payment: PaymentInfo): PaymentStatus => {
    return payment.status
  }
)

export const selectPaymentError = createSelector(
  selectPayment,
  (payment: PaymentInfo): string | undefined => {
    return payment.error
  }
)

// actions
export const {
  setPaymentSessionId,
  setPaymentStatus,
  setPaymentError,
  clearPayment
} = paymentSlice.actions

// reducer
export default paymentSlice.reducer
